module.exports = __webpack_public_path__ + "img/三资备查.707e8de1.png";